import Loader from "@/components/Loader";
import {
  AlertDialogAction,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useTranslation } from "next-i18next";
import { AiOutlineArrowRight } from "react-icons/ai";
import React from "react";
import { enableVideoTutorial } from "@/config/logos";

interface Props {
  nextBtnClick: (step: number, close?: boolean) => any;
  loading: boolean;
  closeButtonClick: (step: number, close?: boolean) => any;
}
const StepCommon: React.FC<Props> = ({
  nextBtnClick,
  loading,
  closeButtonClick,
}) => {
  const { t } = useTranslation("walk-through");
  return (
    <>
      <div className="w-full">
        {enableVideoTutorial && (
          <AspectRatio ratio={16 / 9} className="flex justify-center">
            <iframe
              className="sl-demo absolute top-0 left-0 w-full h-full border shadow-[0_0_18px_rgba(26,19,72,0.15)] rounded-lg box-border"
              src="https://www.youtube.com/embed/9ZYNaF4HgN4"
              name="sl-embed"
              allow="fullscreen; camera; microphone"
            ></iframe>
          </AspectRatio>
        )}
      </div>
      <div className="flex gap-4 flex-col text-center mt-5">
        <div className="text-2xl font-bold not-italic">
          {t("explore.stepCommon.heading")}
        </div>
        <div>{t("explore.stepCommon.text1")}</div>
        <div>{t("explore.stepCommon.text3")}</div>
        <div className="flex justify-center items-center gap-4">
          <AlertDialogCancel
            className="flex items-center gap-2 mt-0"
            onClick={() => closeButtonClick?.(-1, true)}
            disabled={loading}
          >
            {t("explore.stepCommon.cancelText")}{" "}
          </AlertDialogCancel>
          <AlertDialogAction
            className="flex items-center gap-2"
            onClick={() => nextBtnClick?.(4)}
            disabled={loading}
          >
            {t("explore.stepCommon.btnText")}{" "}
            {loading ? <Loader /> : <AiOutlineArrowRight />}
          </AlertDialogAction>
        </div>
      </div>
    </>
  );
};
export default StepCommon;
